import { AfterViewInit, Component, ElementRef, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ParentModule } from '../../ParentClass/parent-module';
import { Subscription } from 'rxjs/Subscription';
import { DomSanitizer } from '@angular/platform-browser';
import { ManifestService } from '../../manifest/manifest.service';
import { GridOptions } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

declare const Cropper: any;
declare const pdfjsLib: any;

@Component({
  selector: 'app-trip-manifest',
  templateUrl: './trip-manifest.component.html',
  styleUrls: ['./trip-manifest.component.scss']
})
export class TripManifestComponent extends ParentModule implements OnInit, AfterViewInit, OnDestroy {

  @Input() tripIdInput?: any;
  @Input() autoOpenInput = true;
  @Input() tripIdsInput?: any[] = [];

  @Output() eventManifestOutput: EventEmitter <any> = new EventEmitter <any>();
  @Output() onRealLoadCheckOutput?: EventEmitter <any> = new EventEmitter <any>();

  @ViewChild('fs') fs: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('img') protected img: ElementRef;
  @ViewChild('fileUpload') protected _fileUpload: ElementRef;

  private configImg = {
    aspectRatio: NaN,
    checkCrossOrigin: true,
    background: true,
    checkOrientation: true,
    scalable: true,
    rotatable: true,
    viewMode: 0
  };
  public imageUrl: any;
  public _cropperImg: any;
  public cropCutout = undefined;
  public infTrip: any;
  public allPages = [];
  public gridTrips: GridOptions;
  private observables: Subscription[] = [];
  private ctx: CanvasRenderingContext2D;
  public initCrop = false;
  public showIndividual = true;
  public isOpenFullscreen = false;

  constructor(
    protected Inject: Injector,
    private sanitizer: DomSanitizer,
    private _manifestService: ManifestService,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    super('app-manifest', Inject);
    this.gridTrips = <GridOptions> {};
    this.gridTrips.columnDefs = this.getColumnDefs();
  }

  ngOnInit() {
    this.loadData(true);
  }

  loadData(openAttachDocument?: boolean) {
    if (this.tripIdInput && this.tripIdsInput.length > 1) {
      this.showIndividual = false;
      this.getTripsByIds();
      setTimeout(() => {
        if (this.autoOpenInput && this.isAllowedAction('Upload Manifest')) {
          this._fileUpload.nativeElement.click();
        }
      }, 1000);
    } else if (this.tripIdInput) {
      this.showIndividual = true;
      this.tripIdsInput = [this.tripIdInput];
      this._manifestService.getManifest(this.tripIdInput).subscribe(
        data => {
          this.infTrip = data;
          if (data.attachment) {
            this._manifestService.setManifestLoaded(true);
            this.updateImg(data.attachment);
          } else {
            if (openAttachDocument) {
              if (this.autoOpenInput && this.isAllowedAction('Upload Manifest')) {
                this._fileUpload.nativeElement.click();
              }
            }
          }
        }, error => {
          this._manifestService.setManifestLoaded(!!this.imageUrl || !!this.cropCutout);
          this.sweetAlertHelper.captureException(error).then(() => {
            if (this.autoOpenInput && this.isAllowedAction('Upload Manifest')) {
              this._fileUpload.nativeElement.click();
            }
          });
        }
      );
    }
  }

  getTripsByIds() {
    this._manifestService.getTripsByIds(this.tripIdsInput).subscribe(
      data => {
        if (this.gridTrips && this.gridTrips.api) {
          this.gridTrips.api.setRowData(data);
        }
      }
    );
  }

  ngAfterViewInit(): void {
    this.ctx = (<HTMLCanvasElement>this.canvas.nativeElement).getContext('2d');
  }

  fileClick() {
    this._fileUpload.nativeElement.click();
  }

  initCropper()  {
    this.destroyCropper();
    this.img.nativeElement.src = this.imageUrl;
    this._cropperImg = new Cropper(this.img.nativeElement, this.configImg);
    this.initCrop = true;
    this.cropCutout = undefined;
  }

  clearCropper() {
    this.destroyCropper();
    this.img.nativeElement.src = this.imageUrl;
    this.initCrop = false;
    this.cropCutout = undefined;
  }

  crop() {
    this.cropCutout = this._cropperImg.getCroppedCanvas({
      width: 1000,
      height: 1000
    }).toDataURL('image/png', 60 / 100);
    this.initCrop = false;
  }

  updateImg(urlImg, selectedImg?: boolean) {
    this.destroyCropper();
    this.imageUrl = urlImg;
    this.img.nativeElement.src = urlImg;
    this.initCrop = false;
    this.cropCutout = undefined;
    if (selectedImg) {
      this._cropperImg = new Cropper(this.img.nativeElement, this.configImg);
      setTimeout(() => {
        const getImageData = this._cropperImg.getCanvasData();
        this._cropperImg.setCropBoxData(getImageData);
        this.cropCutout = this._cropperImg.getCroppedCanvas({
          maxWidth: 4096, maxHeight: 4096
        }).toDataURL('image/png', 60 / 100);
      }, 1000);
    }
  }

  onAttachDocument(event) {
    this.allPages = [];
    this.cropCutout = undefined;
    this.destroyCropper();
    const files = event.srcElement.files;
    if (files.length && files) {
      const ext = files[0].name.split('.').pop();
      const file = URL.createObjectURL(files[0]);
      const img = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'];
      const doc = ['pdf', 'PDF'];

      if (img.indexOf(ext) > -1) {
        /**********************************************************************/
        this.imageUrl = file;
        this.img.nativeElement.src = file;
        this._cropperImg = new Cropper(this.img.nativeElement, this.configImg);
        this.initCrop = true;
        /**********************************************************************/
      } else if (doc.indexOf(ext) > -1) {
        this.convertPdfToImage(file);
      } else {
        this.sweetAlertHelper.createCustomAlert({
          position: 'top-end',
          type: 'error',
          title: 'Format not allowed, use jpg, jpeg, png or pdf formats',
          showConfirmButton: false,
          timer: 3000
        });
      }
    }
  }

  destroyCropper() {
    if (this._cropperImg) {
      this._cropperImg.destroy();
    }
  }

  convertPdfToImage(file) {
    this._loading.show('Loading the PDF');
    pdfjsLib.getDocument(file).promise.then((pdfDoc) => {
      const totalPages = pdfDoc.numPages;

      for (let i = 1; i <= totalPages; i++) {
        pdfDoc.getPage(i).then((page) => {
          const width = window.screen.availWidth - 500;
          const scale_required = width / page.getViewport(1).width;
          const viewport = page.getViewport(scale_required);

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = width;
          canvas.height = viewport.height;

          const renderContext = {
            canvasContext: ctx,
            viewport: viewport
          };

          const renderTask = page.render(renderContext);
          renderTask.promise.then(() => {
            this.allPages.push(canvas.toDataURL());
            this._loading.hiden();
          });
        });
      }
    });
  }

  selectedImg($i: any) {
    const pages = this.allPages;
    this.updateImg(pages[$i], true);
    this.allPages = [];
    this._manifestService.setManifestLoaded(true);
  }

  sanitize(url: string) {
    if (url) {
      return this.sanitizer.bypassSecurityTrustUrl(url);
    }
  }

  onGridReady(grid) {
    grid.api.sizeColumnsToFit();
  }

  eventApproval(e) {
    this.eventManifestOutput.emit(e);
  }

  openFullscreen(): void {
    this.isOpenFullscreen = true;
    this.initCrop = false;
    this.destroyCropper();
    this.img.nativeElement.src = this.imageUrl;
    const conf = {
      aspectRatio: 16 / 9,
      checkCrossOrigin: true,
      background: false,
      checkOrientation: true,
      scalable: true,
      rotatable: true,
      viewMode: 0
    };
    this._cropperImg = new Cropper(this.img.nativeElement, conf);
    setTimeout(() => {
      this._cropperImg.clear();
      this._cropperImg.setDragMode('move');
    }, 1000);

    const el = this.fs.nativeElement;
    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen();
      } else if (el.webkitRequestFullscreen) {
        // el.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (el.msRequestFullscreen) {

        el.msRequestFullscreen();
      }
    }
  }

  closeFullscreen(): void {
    this.isOpenFullscreen = false;
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  }

  saveManifest() {
    this.sweetAlertHelper.createCustomAlert({
      text: 'Are you sure you want to select the current page?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.value) {
        if (this.cropCutout && this.tripIdInput) {
          this._loading.show('Loading Manifest');
          const img = this.cropCutout.split('base64,')[1];
          let data;
          if (this.tripIdsInput && this.tripIdsInput.length > 0) {
            data = {
              Trips: this.tripIdsInput,
              FileBase64: img,
            };
          } else {
            data = {
              Trips: [this.tripIdInput],
              FileBase64: img,
            };
          }
          this._manifestService.postTripManifest(data).subscribe(
            response => {
              this._loading.hiden();
              this._manifestService.setManifestLoaded(true);
              this.updateImg(response.data.attachment);
              this.sweetAlertHelper.createCustomAlert({
                text: 'Manifest Updated...',
                type: 'success',
                confirmButtonText: 'Ok'
              });
              this.onRealLoadCheckOutput.emit();
            }
          );
        } else {
          this.sweetAlertHelper.createCustomAlert({
            text: 'An error occurred trying to save the manifest...',
            type: 'warning',
            confirmButtonText: 'Ok'
          });
        }
      }
    });
  }

  removeFile() {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Are you sure?',
      text: 'You won´t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.deleteManifest();
      }
    });

  }

  deleteManifest() {
    if (this.tripIdInput) {
      // let data;
      // if (this.tripIdsInput && this.tripIdsInput.length > 0) {
      //   data = {
      //     Trips: this.tripIdsInput,
      //     FileBase64: null,
      //   };
      // } else {
      //   data = {
      //     Trips: [this.tripIdInput],
      //     FileBase64: null,
      //   };
      // }

      const data = {
        Trips: this.tripIdInput,
        FileBase64: null,
      };
      this._manifestService.postTripManifest(data).subscribe(
        response => {
          this._manifestService.setManifestLoaded(false);
          this.sweetAlertHelper.createCustomAlert({
            title: 'Deleted!',
            text: 'The file has been deleted.',
            type: 'success',
          }).then(() => {
            this.loadData(true);
          });
          this.onRealLoadCheckOutput.emit();
        }
      );
    }
  }

  getColumnDefs() {
    return [
      {
        headerName: 'Trip Date',
        width: 30,
        field: 'dateofservice'
      },
      {
        headerName: 'Rider',
        width: 60,
        field: 'rider'
      },
      {
        headerName: 'Trip #',
        width: 30,
        field: 'consecutive'
      },
      {
        headerName: 'Call Type',
        width: 40,
        field: 'calltype'
      },
      {
        headerName: 'Leg',
        width: 12,
        field: 'leg'
      },
      {
        headerName: 'Signature',
        width: 40,
        field: 'tripreasonsign'
      },
      {
        headerName: 'Loaded Mi.',
        width: 30,
        field: 'miles'
      },
      {
        headerName: 'Driver',
        width: 60,
        field: 'driver'
      },
      {
        headerName: 'PUT',
        width: 30,
        field: 'actualpickup'
      },
      {
        headerName: 'PU Ad.',
        width: 60,
        field: 'puaddress'
      },
      {
        headerName: 'DOT',
        width: 30,
        field: 'actualdropoff'
      },
      {
        headerName: 'DO Add',
        width: 60,
        field: 'doaddress'
      }
    ];
  }

  ngOnDestroy(): void {
    this.observables.forEach(item => item.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/trip-manifest/trip-manifest/trip-manifest.component.ts